import React from "react";
import { Typography, Link, Skeleton } from "@mui/material";
import { NavLink } from "react-router-dom";

const RefundInfo = ({ loading, title, value, link }) =>
  loading ? (
    <>
      <Skeleton variant="text" width={60} sx={{ fontSize: "0.7rem" }} />
      <Skeleton variant="text" width={120} sx={{ fontSize: "1rem" }} />
    </>
  ) : (
    <>
      <Typography variant="caption">{title}</Typography>
      {link ? (
        <Link component={NavLink} to={link}>
          <Typography variant="body2" component="div" noWrap>
            {value}
          </Typography>
        </Link>
      ) : (
        <Typography variant="body2" component="div" noWrap>
          {value}
        </Typography>
      )}
    </>
  );

export default RefundInfo;
